import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import '../assets/style/lywo-style.css'; 

const GripIcon = (props) => (
  <svg {...props} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/>
    <circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/>
  </svg>
);

const fallbackQuestions = [
  { id: 'q1', q: 'What is the primary purpose of a load balancer?' },
  { id: 'q2', q: 'Explain the difference between SQL and NoSQL databases.' },
  { id: 'q3', q: 'What are React Hooks and why are they useful?' }
];

const ReorderQuestionsList = ({ questions = fallbackQuestions, onSave = () => {}, isOpen = true, onClose = () => {} }) => {
  const [list, setList] = useState([...(questions || fallbackQuestions)]);
  const [draggedIdx, setDraggedIdx] = useState(null);
  const [dragOverIdx, setDragOverIdx] = useState(null);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  const navigate = useNavigate();

  const handleSort = () => {
    if (dragItem.current !== null && dragOverItem.current !== null && dragItem.current !== dragOverItem.current) {
      let _list = [...list];
      const draggedItemContent = _list.splice(dragItem.current, 1)[0];
      _list.splice(dragOverItem.current, 0, draggedItemContent);
      setList(_list);
    }
    dragItem.current = null;
    dragOverItem.current = null;
  };

  // Close logic for the 'X' button
  const handleDismiss = () => {
    if (onClose) {
      onClose(); // Parent function call
    }
    // navigate(-1); // Going back as requested
  };

  if (!isOpen) return null;

  return (
    /* Background Overlay */
    <>
    {
        isOpen &&
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      padding: '20px'
    }}>
      
      {/* Larger Modal Container */}
      <div style={{ 
        width: '100%', 
        maxWidth: '800px', 
        height: '85vh',
        background: '#fff', 
        borderRadius: '12px',
        display: 'flex', 
        flexDirection: 'column', 
        overflow: 'hidden',
        // boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
      }}>
        
        {/* Header */}
        <div style={{ 
          padding: '20px 24px', 
          borderBottom: '1px solid #eaecf0', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <div>
            <h3 className="fw-semibold font-size-h3 text-dark-navy" style={{ margin: 0 }}>Reorder Questions</h3>
            <p className="text-muted font-size-h4" style={{ margin: '4px 0 0 0' }}>Adjust the sequence of your interview questions</p>
          </div>
          {/* Working Wrong Symbol (X) */}
         <button 
  onClick={handleDismiss} 
  style={{ 
    background: 'transparent', 
    border: 'none', 
    outline: 'none', 
    cursor: 'pointer', 
    fontSize: 'var(--font-size-h1)', 
    width: '32px', 
    height: '32px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    color: '#000', 
    padding: 0, 
  }}
>
  ×
</button>
        </div>

        {/* Scrollable Body */}
        <div style={{ padding: '24px', flex: 1, overflowY: 'auto', background: '#fcfcfd' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {list.map((q, idx) => (
              <div
                key={q.id || idx}
                draggable
                onDragStart={(e) => {
                  dragItem.current = idx;
                  setDraggedIdx(idx);
                }}
                onDragEnter={() => {
                  dragOverItem.current = idx;
                  setDragOverIdx(idx);
                }}
                onDragEnd={() => {
                  handleSort();
                  setDraggedIdx(null);
                  setDragOverIdx(null);
                }}
                onDragOver={(e) => e.preventDefault()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '16px',
                  border: '1px solid var(--ui-border)',
                  borderRadius: '8px',
                  background: draggedIdx === idx ? 'var(--brand-bg)' : '#fff',
                  cursor: 'grab',
                  opacity: draggedIdx === idx ? 0.6 : 1,
                  boxShadow: dragOverIdx === idx && draggedIdx !== idx
                             ? (draggedIdx < idx ? '0 4px 0 0 var(--brand-accent)' : '0 -4px 0 0 var(--brand-accent)')
                             : '0 1px 2px rgba(16, 24, 40, 0.05)',
                }}
              >
                <GripIcon className="text-placeholder font-size-h3" style={{ marginRight: '16px' }} />
                <div className="font-size-h4 d-flex" style={{ gap: '8px' }}>
                    <span className="fw-bold text-brand-accent" style={{ minWidth: '30px' }}>Q{idx + 1}.</span>
                    <span className="fw-medium text-dark-ui">{q.q || q.text}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="lywo-modal-footer" style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '16px 24px',
          borderTop: '1px solid var(--ui-border)',
          background: '#f8f9fa'
        }}>
          <button
  className="btn btn-outline-primary" 
  onClick={onClose} // navigate(1) काढून टाका
  style={{
    fontSize: 'var(--font-size-h4)',
    marginRight: '10px',
    padding: '6px 16px',
    border: '1px solid var(--brand-primary)',
    borderRadius: '6px',
    background: 'transparent',
    color: 'var(--brand-primary)',
    cursor: 'pointer'
  }}
>
  Cancel
</button>
         <button
  className="btn btn-primary"
  onClick={() => {
    console.log("Saving this data:", list); 
    if (typeof onSave === 'function') {
      onSave(list); 
      if (typeof onClose === 'function') onClose(); 

      
    }
  }}
  style={{
    height: '36px',
    padding: '0 24px',
    fontSize: 'var(--font-size-h4)',
    background: 'var(--brand-accent)',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600'
  }}
>
  Save Order
</button>
        </div>
      </div>
    </div>
    
    }
    </>
  );
};

export default ReorderQuestionsList;